export interface WorkflowAction {
  label: string,
  code: string
}

export interface WorkflowActions {
  prev?: WorkflowAction,
  next?: WorkflowAction
}

export interface WorkflowState {
  id?: number,
  label?: string,
  referenceKey?:string,
  pageName?: string,
  stateKey?: string,
  stateFlag?: string,
  severity?: 'secondary' | 'success' | 'info' | 'warn' | 'danger',
  workingPhase?:number;
  disabledFields?: string[],
  readonly?: boolean,
  actions?: WorkflowActions,
  list?: WorkflowState[]
}


const COMPLETA_PREVENTIVO: WorkflowAction = {label: 'Completa preventivo', code:'COMPLETA_PREVENTIVO' };
const INVIA_PREVENTIVO: WorkflowAction = {label: 'Preventivo inviato', code:'INVIA_PREVENTIVO' };
const ACCETTA_PREVENTIVO: WorkflowAction ={label: 'Preventivo accettato', code:'ACCETTA_PREVENTIVO'};
const RIFIUTA_PREVENTIVO: WorkflowAction ={label: 'Preventivo rifiutato', code:'RIFIUTA_PREVENTIVO' };
const COMPLETA_PROGETTAZIONE: WorkflowAction ={label: 'Progettazione completa', code:'COMPLETA_PROGETTAZIONE'};
const COMPLETA_RICHIESTA_MATERIALE: WorkflowAction ={label: 'Verifica completata', code:'COMPLETA_RICHIESTA_MATERIALE'};
const INIZIA_LAVORAZIONE: WorkflowAction ={label: 'Inizia lavorazione', code:'INIZIA_LAVORAZIONE'};
const COMPLETA_LAVORAZIONE: WorkflowAction ={label: 'Completa lavorazione', code:'COMPLETA_LAVORAZIONE'};
const COMPLETA_CONSUNTIVO: WorkflowAction ={label: 'Completa consuntivo', code:'COMPLETA_CONSUNTIVO'};
const SPEDITO: WorkflowAction ={label: 'Spedito', code:'SPEDITO'};
const CONSEGNATO: WorkflowAction ={label: 'Consegnato', code:'CONSEGNATO'};
const BACK: WorkflowAction ={label: 'Indietro', code:'BACK'};

export const OrdineWorkflow: WorkflowState[] = [
  { id: undefined, label: 'Tutti', disabledFields:[]},
  { id: 1, label: 'Bozza', disabledFields:[], severity:'secondary' },
  { id: 2, label: 'In corso', disabledFields:['positions'], severity:'warn' },
  { id: 3, label: 'Archiviata', disabledFields:['positions'], readonly: true, severity:'success'  },
  //{ id: 4, label: 'Archiviata', disabledFields:['positions'], readonly: true  }
]
export const EquipmentRequestWorkflow:WorkflowState[] = [
  { id: undefined, label: 'Tutti' },
  { id: 1, label: 'Da ordinare', severity:'danger' },
  { id: 2, label: 'Ordinato', severity:'warn' },
  { id: 3, label: 'Arrivato', severity:'success' }
]

export const OperationWorkflow:WorkflowState[] = [
  { id: undefined, label: 'Verifica materiale' },
  { id: 1, label: 'Verifica materiale' },
  { id: 2, label: 'Attesa materiale' },
  { id: 3, label: 'Attesa precedente' },
  { id: 4, label: 'Pronto alla lavorazione' },
  { id: 5, label: 'In lavorazione' },
  { id: 6, label: 'Completo' },
]

export const BozzaWorkflow:WorkflowState = {
  id: 1,
  label: 'Bozza',
  pageName: 'Bozza',
  stateKey: 'Bozza',
};


export const PreventiveWorkflow:WorkflowState = {
  id: 2,
  label: 'Preventivo',
  pageName: 'Preventivi',
  stateKey: 'preventiveStateId',
  stateFlag:'preventiveFlag',
  referenceKey:'preventiveReference',
  workingPhase:1,
  list: [
    { id: undefined, label: 'Tutti' },
    { id: 1, label: 'Da Preventivare', disabledFields:['sendDate', 'expireDate'],  actions:{next: COMPLETA_PREVENTIVO}, severity:'danger' },
    { id: 2, label: 'Da inviare', disabledFields:['operations', 'materials', 'tools', 'total', 'profitMarginPerc', 'totalCalculated', 'reference'],  actions:{next: INVIA_PREVENTIVO, prev: BACK}, severity:'warn' },
    { id: 3, label: 'Inviato', readonly:true,  actions:{prev: RIFIUTA_PREVENTIVO, next: ACCETTA_PREVENTIVO} , severity:'warn' },
    { id: 4, label: 'Accettato', readonly:true , severity:'success' }
  ]
};
export const ProjectWorkflow:WorkflowState = {
  id: 3,
  label: 'Progettazione',
  pageName: 'Progettazioni',
  stateKey: 'projectStateId',
  stateFlag:'projectFlag',
  referenceKey:'projectReference',
  workingPhase:2,
  list: [
    { id: undefined,  label: 'Tutti' },
    { id: 1, label: 'Da Progettare', actions:{next: COMPLETA_PROGETTAZIONE}, severity:'danger' },
    { id: 2,  label: 'Progettazione Completata',readonly:true, severity:'success' }
  ]
};
export const ProductionWorkflow:WorkflowState = {
  id: 4,
  label: 'Produzione',
  pageName: 'Produzioni',
  stateKey: 'productionStateId',
  stateFlag:'productionFlag',
  referenceKey:'productionReference',
  workingPhase:3,
  list: [
    { id: undefined, label: 'Tutti' },
    { id: 1, label: 'Verifica Magazzino', disabledFields:['sendDate', 'expireDate','total', 'profitMarginPerc', 'totalCalculated'], actions:{next: COMPLETA_RICHIESTA_MATERIALE}, severity:'danger' },
    { id: 2, label: 'Attesa Materiale', disabledFields:['sendDate', 'expireDate','total', 'profitMarginPerc', 'totalCalculated'], actions:{prev: BACK}, severity:'danger' },
    { id: 3, label: 'Pronto alla lavorazione', disabledFields:['sendDate', 'expireDate','total', 'profitMarginPerc', 'totalCalculated'], actions:{next: INIZIA_LAVORAZIONE, prev: BACK}, severity:'warn'  },
    { id: 4, label: 'In Lavorazione', disabledFields:['materials', 'tools', 'sendDate', 'total', 'profitMarginPerc', 'totalCalculated', 'reference'], actions:{next: COMPLETA_LAVORAZIONE, prev: BACK}, severity:'info' },
    { id: 5, label: 'Da Consuntivare', disabledFields:['materials', 'tools', 'sendDate', 'total', 'profitMarginPerc', 'totalCalculated', 'expireDate', 'reference'], actions:{next: COMPLETA_CONSUNTIVO, prev: BACK}, severity:'warn' },
    { id: 6, label: 'Produzione Finita', readonly:true, disabledFields:['materials', 'tools', 'sendDate', 'total', 'profitMarginPerc', 'totalCalculated', 'expireDate', 'reference'], severity:'success' }
  ]
};
export const ShippingWorkflow:WorkflowState = {
  id: 5,
  label: 'Spedizione',
  pageName: 'Spedizioni',
  stateKey: 'shippingStateId',
  stateFlag:'shippingFlag',
  list: [
    { id: undefined, label: 'Tutti' },
    { id: 1, label: 'Da spedire', disabledFields:['deliveryDate'], actions:{next: SPEDITO}, severity:'danger' },
    { id: 2, label: 'In Viaggio', disabledFields:['courierType', 'vehicleId', 'sendDate', 'weight', 'courierName', 'parcel'], actions:{next: CONSEGNATO, prev: BACK}, severity:'warn' },
    { id: 3, label: 'Consegnato', readonly:true, actions:{prev: BACK}, severity:'success' }
  ]
};
export const PositionWorkflow:WorkflowState = {
  label: 'Posizione',
  pageName: 'Posizioni',
  stateKey: 'positionStateId',
  list: [
     { id: undefined, label: 'Tutti', list: [] },
    PreventiveWorkflow,
    ProjectWorkflow,
    ProductionWorkflow,
    ShippingWorkflow,
    { id: 6, label: 'Completato', list: [], readonly:true },
    ]
};